import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { Tab, Col, Row, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { academylist, leaveapprove, leavedetail, leavelist, leavereject } from "../../../services/admin";
import moment from "moment";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from "react-select";

export default function Leavedetails() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [fromdate, setFromDate] = useState("");
  const [todate, setToDate] = useState("");
  const [ltype, setLType] = useState("All");

  const [lreason, setLReason] = useState("");


  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const columnDefs = [
     {
      headerName: "Action",
      field: "id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="btn-sm btn-info me-1"
              onClick={() => viewdet(params.value)}
            >
              <i className="fa fa-eye"></i>
            </a>
            {(localStorage.getItem("Role") === "1" ||
              localStorage.getItem("Role") === "2" ||
              localStorage.getItem("UID") == params.data.user_id) && (
                <a
                  className="btn-sm btn-success"
                  onClick={() => editdet(params.value)}
                >
                  <i className="fa fa-edit"></i>
                </a>
              )}
          </div>
        );
      },
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: params => {
        if (params.value === 'Approved') {
          return { color: 'green', fontWeight: "bold" };
        } else if (params.value === 'Rejected') {
          return { color: 'red', fontWeight: "bold" }
        } else if (params.value === 'Pending') {
          return { color: 'blue', fontWeight: "bold" }
        } else {
          return { color: 'brown', fontWeight: "bold" }
        }
      }

    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Role",
      field: "role_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Leave",
      field: "leave_permission",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "leave_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Days/Hours",
      field: "total_leave",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "From Date",
      field: "from_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "To Date",
      field: "to_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "Reason",
      field: "reason",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
   
  ];

  const columnLDefs = [
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: params => {
        if (params.value === 'Approved') {
          return { color: 'green', fontWeight: "bold" };
        } else if (params.value === 'Rejected') {
          return { color: 'red', fontWeight: "bold" }
        } else if (params.value === 'Pending') {
          return { color: 'blue', fontWeight: "bold" }
        } else {
          return { color: 'brown', fontWeight: "bold" }
        }
      }

    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Role",
      field: "role_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Leave",
      field: "leave_permission",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "leave_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Days/Hours",
      field: "total_leave",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "From Date",
      field: "from_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "To Date",
      field: "to_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
    {
      headerName: "Reason",
      field: "reason",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

  ];
  const [urllink, setUrl] = useState("");
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrl(path);

    if (path === "leavereport") {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setACList(arr);
          }
        }
      });
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                }
              }
             
            }
          }
        });
      }
    }
    if (localStorage.getItem("ADate") !== '') {
          listall(
            moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
            moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
            'All', ''
          );
        } else {
          listall(
            moment(new Date()).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD"),
            'All', ''
          );
        }

    
  }, []);

  function listall(fdate, tdate, ptype, aca) {
    setFilterProduct([]);
    setFromDate(fdate);
    setToDate(tdate);
    setLType(ptype);
    const temp = new FormData();
    temp.append("from_date", fdate);
    temp.append("to_date", tdate);
    temp.append("type", ptype);
    if(localStorage.getItem("Role") === "1" && aca !== '') {
      temp.append("academy_id", aca.value);
    }else if(localStorage.getItem("Role") !== "1"){
      temp.append("academy_id", localStorage.getItem("academy"));
    }
    leavelist(temp).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }

  const [ldetail, setLdetail] = useState("");
  const [llogo, setLLogo] = useState("");
  const [luser, setLUser] = useState("");

  function viewdet(vid) {
    setLReason("");
    leavedetail(vid).then((response) => {
      if (response.status === true && response.data.details) {
        if (response.data.logo !== null) {
          setLLogo(response.data.path + response.data.logo);
        }
        setLdetail(response.data.details);
        if (response.data.details.rejected_reason) {
          setLReason(response.data.details.rejected_reason);
        }
        setLUser(response.data.username);
        setShow(true);
      }
    });
  }

  function editdet(eid) {
    leavedetail(eid).then((response) => {
      if (response.status === true && response.data.details) {
        if (response.data.details.active == 2) {
          Swal.fire({
            title: "Leave is already approved! So you can't edit it!",
            icon: "warning",
            showCancelButton: false,
          });
        } else if (response.data.details.active == 3) {
          Swal.fire({
            title: "Leave is already rejected! So you can't edit it!",
            icon: "warning",
            showCancelButton: false,
          });
        } else if (response.data.details.active == 1) {
          navigate(`/leavemanagement/leavedetail/${eid}`);
        }
      }
    });
  }
  const errorphoto = (ev) => {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  };
  const [errmsg, setErrmsg] = useState("");
  function leavesubmit(ltid, sid) {
    if (ltid == 1) {
      Swal.fire({
        text: "Are you sure want to Approve?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Approve",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", sid);
          leaveapprove(temp).then((response) => {
            if (response.status === true) {
              setShow(false);
              listall(fromdate, todate, ltype, acaid);
            }
          });
        }
      });
    } else if (ltid == 2) {
      setErrmsg("");
      if (lreason !== "") {
        Swal.fire({
          text: "Are you sure want to Reject?",
          icon: "warning",

          showCancelButton: true,
          confirmButtonColor: "#ac0404",
          cancelButtonColor: "#6259ca",
          confirmButtonText: "Reject",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            const temp = new FormData();
            temp.append("id", sid);
            temp.append("reason", lreason);
            leavereject(temp).then((response) => {
              if (response.status === true) {
                setShow(false);
                listall(fromdate, todate, ltype, acaid);
              }
            });
          }
        });
      } else {
        setErrmsg("Please enter reason");
      }

    }
  }
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(fromdate, todate, ltype, e);
    } else {
      setAcaID("");
      listall(fromdate, todate, ltype, '');
    }
  }
  function submitrep(e) {
    e.preventDefault();
    const reportUrl = localStorage.getItem("reportUrl");
    window.open(reportUrl + 'report/leavereport?from_date=' + fromdate + '&to_date=' + todate + '&type=' + ltype, "_blank");
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "leavereport" ? "Leave Report" : "Leave Details"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{urllink === "leavereport" ? "Reports" : "Leave Management"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "leavereport" ? "Leave Report" : "Leave Details"}
          </li>
        </ol>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              {urllink !== "leavereport" &&
                <div className="card-header">
                  <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Leave List</h2>{" "}
                  </div>
                </div>
              }

              <Row>
                {urllink !== "leavereport" &&
                  <>
                    <Col xxl={3} lg={3} md={3}>
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromdate}
                        onChange={(e) => listall(e.target.value, todate, ltype, acaid)}
                      />
                    </Col>
                    <Col xxl={3} lg={3} md={3}>
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={todate}
                        onChange={(e) => listall(fromdate, e.target.value, ltype, acaid)}
                      />
                    </Col>
                  </>
                }

                {urllink === "leavereport" &&
                  <>
                    {localStorage.getItem("Role") === "1" && (
                      <Col xxl={4} lg={4} md={4}>
                        <label className="form-label">
                          Select Academy <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />

                      </Col>
                    )}
                    <Col xxl={4} lg={4} md={4}>
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromdate}
                        onChange={(e) => listall(e.target.value, todate, ltype, acaid)}
                      />
                    </Col>
                    <Col xxl={4} lg={4} md={4}>
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={todate}
                        onChange={(e) => listall(fromdate, e.target.value, ltype, acaid)}
                      />
                    </Col>
                    {urllink === "leavereport" &&
                      <>
                        <Col xxl={4} lg={4} md={4}>
                          <label className="form-label">Type</label>
                          <select className="form-control" value={ltype} onChange={(e) => listall(fromdate, todate, e.target.value, acaid)}>
                            <option value="" selected disabled>Select Type</option>
                            <option value="Leave">Leave</option>
                            <option value="Permission">Permission</option>
                            <option value="All">All</option>
                          </select>
                        </Col>
                        <Col xxl={8} lg={8} md={8}>
                          <div className="res-right mt-5">
                            <button className="btn btn-success me-2" onClick={submitrep}>
                              Excel Download
                            </button>

                          </div>
                        </Col>
                      </>
                    }
                  </>
                }

              </Row>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={urllink === "leavereport" ? columnLDefs : columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} size="lg">
        <Modal.Header>
          <Modal.Title>Leave Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm">
            <Col md={12} lg={12}>
              {ldetail.active == 2 && (
                <h5 className="text-success text-center">
                  Leave Application is Approved{" "}
                </h5>
              )}
              <Card className=" mg-b-20 border">
                <div className="p-4 card-headerr">
                  <div className="media">
                    <div className="media-user me-2">
                      <div className="main-img-user avatar-md">
                        <img src={llogo} alt="Photo" onError={errorphoto} />
                      </div>
                    </div>
                    <div className="media-body">
                      <h6 className="mb-0 mg-t-2 ms-2">
                        {luser}
                        <span className="text-muted ms-2">
                          {moment(ldetail.created_at).format("DD MMM YYYY")}
                        </span>
                      </h6>
                      <h6 className="mb-0 mg-t-2 ms-2">
                        {ldetail.leave_permission === "Leave"
                          ? `${ldetail.total_leave} Days (` +
                          `${ldetail.from_date} to ${ldetail.to_date} )`
                          : ` (${ldetail.total_leave} Hrs)`}
                      </h6>

                      <span className="ms-2 Priority">
                        {ldetail.leave_type}
                      </span>
                    </div>
                  </div>
                </div>
                <Card.Body>
                  <h3>Reason</h3>
                  <p className="mg-t-0">{ldetail.reason}</p>
                </Card.Body>
              </Card>
            </Col>
            {(localStorage.getItem("Role") === "1" ||
              localStorage.getItem("Role") === "2") &&
              (ldetail.active == 1 || ldetail.active == 3) && (
                <Col md={12} lg={12}>
                  <label className="form-label">
                    Reject Reason <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    onChange={(e) => setLReason(e.target.value)}
                    value={lreason}
                  ></textarea>
                </Col>
              )}
            {errmsg && <p className="text-danger">{errmsg}</p>}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {(localStorage.getItem("Role") === "1" ||
            localStorage.getItem("Role") === "2") &&
            ldetail.active == 1 && (
              <>
                <button
                  className="btn btn-success"
                  onClick={() => leavesubmit(1, ldetail.id)}
                >
                  Approved
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => leavesubmit(2, ldetail.id)}
                >
                  Reject
                </button>
              </>
            )}

          <button className="btn btn-secondary" onClick={() => setShow(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
